// Slides accueil
(function($) {
    var slides = document.querySelectorAll(".acc-slide");
    if (slides.length < 1) return;
    for (var i = 0; i < slides.length; i++) {
        slides[i].id = (slides[i].id === "" ? "" : " ") + "s" + (i + 1);
    }

    $("body.home #et-boc > .et_builder_inner_content").mousewheel(function(event) {
        clear_interval();
        scroll(event);
    });

    $("#acc-scroller").click(function() {
        clear_interval();
        scroll({deltaY: -1});
    });

    window.auto_slides_interval = setInterval(function() {
        scroll({deltaY: -1});
    }, 6000);

    function scroll(event) {
        if (typeof window.acc_scrolling !== "undefined" && window.acc_scrolling) return;
        if ($(window).width() < 1251) return;

        var hash = window.location.hash;
        document.querySelector("#main-content");
        var current = 1;
        if (/^#s\d$/.test(hash)) {
            current = parseInt(hash.substr(2));
        }

        var goto = current;
        if (event.deltaY === 1) {
            if (current > 1) goto = current - 1;
        } else {
            goto = current + 1;
        }

        if (goto !== current && document.getElementById("s" + goto)) {
            window.acc_scrolling = true;
            setTimeout(function() {
                window.acc_scrolling = false;
            }, 600);
            window.location.replace("#s" + goto);
            check_next(goto);
        }
    }

    function check_next(current) {
        if (!current) {
            var hash = window.location.hash;
            document.querySelector("#main-content");
            current = 1;
            if (/^#s\d$/.test(hash)) {
                current = parseInt(hash.substr(2));
            }
        }

        var next = document.getElementById("s" + (current + 1));
        var acc_scroller = document.getElementById("acc-scroller");
        if (next && acc_scroller) {
            acc_scroller.style.opacity = "1";
            acc_scroller.style.pointerEvents = "unset";
        } else if (!next && acc_scroller) {
            acc_scroller.style.opacity = "0";
            acc_scroller.style.pointerEvents = "none";
            clear_interval();
        }
    }

    function clear_interval() {
        if (typeof window.auto_slides_interval !== "undefined" && window.auto_slides_interval !== null) {
            clearInterval(window.auto_slides_interval);
            window.auto_slides_interval = null;
        }
    }
    check_next(0);
}(jQuery));

// Text animation
(function(){
    // Wrap every letter in a span
    var text_wrappers = document.querySelectorAll('.fade-letters');
    if (text_wrappers.length < 1) return;
    for (var i = 0; i < text_wrappers.length; i++) {
        text_wrappers[i].innerHTML = text_wrappers[i].textContent.replace(/\S/g, "<span class='lfade'>$&</span>");
    }

    anime({
        targets: ".lfade",
        opacity: [0, 1],
        delay: anime.stagger(100),
        easing: "easeInOutQuad"
    });
}());

// Fix Divi's animations
(function($) {
    $("#main-content, .et_builder_inner_content").on('scroll', function() {
        var resize_event = window.document.createEvent('UIEvents');
        resize_event.initUIEvent('resize', true, false, window, 0);
        window.dispatchEvent(resize_event);
    });
}(jQuery));

// (function() {
//     var elems = document.querySelectorAll('.kenb-bg');
//     if (elems.length < 1) return;
//     for (var i = 0; i < elems.length; i++) {
//         elems[i].style.backgroundSize = '110%';
//     }
// }());
